import React, { useEffect, useState } from 'react'
import AuthCardComponent from '../../../components/login-card/auth-card.component'
import '../auth.css';
import { Steps } from 'antd';
import SavingCard from '../../../containers/sign-up/saving-card';
import { SignUpContext } from './signup-context';
import PatientInformation from '../../../containers/sign-up/patient-information';
import Creating from '../../../containers/sign-up/creating';
import { useLocation } from 'react-router-dom';

const SignUpPage = () => {
    const location = useLocation();
    const [current, setCurrent] = useState(0);
    const [currentProcess, setCurrentProcess] = useState(0);
    const [buttonEle, setButtonEle] = useState(null);
    const [registrationToken, setRegistrationToken] = useState('');
    const [patientForm, setPatientForm] = useState({
        memberId: "",
        firstName: "",
        lastName: "",
        dob: null,
        email: "",
        gender: "",
        phone: {
            code: "",
            number: "",
        },
        address: {
            line1: "",
            line2: "",
            city: "",
            state: "",
            zip: "",
        },
        copayCardInfo: {
            programId: "",
            programName: "",
            cardGroup: "",
            memberId: "",
        },
        insuranceCard: {
            rxBin: "",
            rxGroup: "",
            rxPcn: "",
        }
    });

    const steps = [
        {
            title: 'Saving Card',
            content: 'saving-card',
            element: [
                {
                    title: "Saving Card Information",
                    description: ""
                }
            ]
        },
        {
            title: 'Patient Information',
            content: 'patient-information',
            element: [
                {
                    title: "Patient Information",
                    description: "Please complete a few easy steps to set up your account."
                },
                {
                    title: "Patient Details",
                    description: ""
                }
            ]
        },
    ];

    const items = steps.map(item => ({ key: item.title, title: item.title }));

    let contextProps = {
        patientForm: patientForm,
        setPatientForm: setPatientForm,
        setFooterButton: setButtonEle,
        setCurrent: setCurrent,
        setCurrentProcess: setCurrentProcess,
        registrationToken: registrationToken, 
        setRegistrationToken: setRegistrationToken,
    }

    useEffect(() => {
        if (location.state === null) return;
        if (location.state.email) {
            setPatientForm((prev) => ({
                ...prev,
                email: location.state.email
            }))
        }
    }, [location])

    return (
        <SignUpContext.Provider value={contextProps}>
            <div className='auth-layout'>
                <div className='d-flex flex-column align-items-center w-100 gap-sm-5'>
                    {
                        current < steps.length && (
                            <Steps className='steps-layout' current={current} items={items} />
                        )
                    }
                    <AuthCardComponent
                        title={steps[current]?.element[currentProcess]?.title || ''}
                        description={steps[current]?.element[currentProcess]?.description || ''}
                        buttonEle={buttonEle}
                        topIcon={steps[current]?.topIcon || null}
                    >
                        {(() => {
                            switch (current) {
                                case 0:
                                    return <SavingCard />
                                case 1:
                                    return <PatientInformation />
                                case 2:
                                    return <Creating />
                                default:
                                    return
                            }
                        })()}
                    </AuthCardComponent>
                </div>
            </div>
        </SignUpContext.Provider>
    )
}

export default SignUpPage